import React from "react";

import { Link } from "../common/Link";
import { IFormButtonLink } from "../models/formFields";
import { FormFieldWrapper } from "./FormFieldWrapper";

export const FormButtonLink = (props: IFormButtonLink): React.ReactNode => {
    return (
        <FormFieldWrapper {...props}>
            <Link
                href={props.href}
                className="button button--inverse"
                target={props.target || "_top"}
            >
                {props.text}
            </Link>
        </FormFieldWrapper>
    );
};
